// ** React Imports
import { useContext } from "react";

// ** React Router
import { useLocation, matchPath } from "react-router-dom";

// ** Custom Components
import Dropdown from "components/layout/Dropdown";
import { DropdownTriggerContext } from "components/layout/Dropdown/DropdownTriggerContext";

// ** Custom Hooks
import useOpenClose from "hooks/useOpenClose";

// ** Text Editor Components
import { EMOJIS } from "./constants";
import { Button } from "../../button/style";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Styled Components
import { StyledGridWrapper, StyledEmojiButton } from "./styles";

// ** SVG Static Imports
import { ReactComponent as RegularSmile } from "resources/icons/regular/smile.svg";

// #####################################################

const EmojiModal = ({ insertEmoji, editorRef, disabled, inline }) => {
	const { isOpen, close, toggle } = useOpenClose();
	const location = useLocation();
	const { isDesktop } = useContext(deviceTypeContext);

	const isModalOpen = matchPath(location.hash.slice(1), {
		path: "users/:login/:type/:contentId/:album?",
	});

	// #####################################################
	return (
		<Dropdown
			isEmojiModal
			isOpen={isOpen}
			close={close}
			withMobileVersion={false}
			useLayerOptions={{
				triggerOffset: 0,
				auto: true,
				placement: "top-end",
				possiblePlacements: ["top-end", "bottom-end"],
				overflowContainer: isDesktop && !isModalOpen,
				container: isDesktop && !isModalOpen ? "main" : null,
			}}
			minWidth
			withShadow
			menuContent={() =>
				isOpen && (
					<StyledGridWrapper className="emojiModal">
						{EMOJIS.map(({ emoji, id }) => (
							<StyledEmojiButton
								className="emojiModal"
								key={id}
								onClick={(event) => {
									event.preventDefault();

									insertEmoji(emoji);
									close();
								}}
								label="emoji"
							>
								<span className="emojiModal">{emoji}</span>
							</StyledEmojiButton>
						))}
					</StyledGridWrapper>
				)
			}
		>
			<DropdownTriggerContext.Consumer>
				{({ triggerProps }) => (
					<Button
						innerRef={triggerProps.ref}
						onMouseDown={(event) => {
							event.preventDefault();
							event.stopPropagation();
						}}
						onMouseUp={(event) => {
							event.preventDefault();
							event.stopPropagation();
						}}
						onClick={(event) => {
							event.preventDefault();
							event.stopPropagation();
							if (editorRef) {
								if (
									document.activeElement !==
									editorRef?.internal?.contenteditable
										?.current
								) {
									editorRef?.current?.focus();

									const containerForCarret =
										editorRef?.internal?.core?.current
											?.selection;

									const carretInsertionPoint =
										editorRef?.internal?.contenteditable
											?.current?.lastChild?.lastChild;

									containerForCarret?.setCursor(
										carretInsertionPoint
									);
								}
							}
							toggle();
						}}
						active={isOpen}
						style={
							inline
								? { height: undefined }
								: {
										height: "33px",
										marginRight: "1px",
										marginTop: "1px",
								  }
						}
						noBackgroundColor
						icon="smile"
						iconType="far"
						svgIconComponent={RegularSmile}
						svgIconComponentActive={RegularSmile}
						iconOnly
						noBorder
						label="Emotikony"
						key="emojiButton"
						disabled={disabled}
					/>
				)}
			</DropdownTriggerContext.Consumer>
		</Dropdown>
	);
};

// #####################################################

export default EmojiModal;

// #####################################################
